// @ts-nocheck
import BankOutlined from '@ant-design/icons/BankOutlined'
import CheckOutlined from '@ant-design/icons/CheckOutlined'
import TeamOutlined from '@ant-design/icons/TeamOutlined'
import UserOutlined from '@ant-design/icons/UserOutlined'
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Space,
  Tabs,
  Tag,
  Tooltip,
} from 'antd'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import queryString from 'query-string'
import React, { memo, useCallback, useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { blue, yellowPrimary } from '../../../color'
import { AvatarHasName } from '../../../components/Common/Avatar'
import SelectGroupPopup from '../../../components/SelectGroupPopup/SelectGroupPopup'
import SelectPeoplePopup from '../../../components/SelectPeoplePopup/SelectPeoplePopup'
import {
  ASSIGNEE_TYPE,
  DATE_FORMAT_DEFAULT,
  ISO_DATE_FORMAT,
  WORK_STATUS,
} from '../../../constants'
import { SelectList } from '../../MissionCreatePage/MissionCreatePageStyled'

const { Option } = Select
const { RangePicker } = DatePicker
const { TabPane } = Tabs

const Search = props => {
  const {
    workStore,
    handleCloseCollapse,
    selectPeopleStore,
    dispatchUserFilter,
    selectedRowKeys,
    setSelectedRowKeys,
    markAsReadLoading,
    setMarkAsReadLoading,
  } = props
  const {
    selectUserData,
    selectGroupData,
    assigneePopupType,
    selectDepartmentData,
    isVisibleSelectGroupPopup,
    handleOpenSelectGroupPopup,
    isVisibleSelectUserDepartmentPopup,
    handleCancelSelectUserDepartment,
    handleCancelSelectGroup,
    setIsVisibleSelectGroupPopup,
    setIsVisibleSelectUserDepartmentPopup,
  } = selectPeopleStore

  const { queryParams } = workStore
  const [form] = Form.useForm()
  const location = useLocation()
  const history = useHistory()
  const queryStringParse = queryString.parse(location.search)
  const [createList, setCreateList] = useState([])
  const [handlerList, setHandlerList] = useState([])

  useEffect(() => {
    form.setFieldsValue({
      search: queryParams.title || null,
      date:
        queryParams.from_date && queryParams.to_date
          ? [moment(queryParams.from_date), moment(queryParams.to_date)]
          : null,
      status: queryParams.is_due_soon
        ? 'DUE_SOON'
        : queryParams.status || undefined, // Đồng bộ trạng thái với queryParams
    })
  }, [queryParams, form])

  useEffect(() => {
    setCreateList([
      ...(selectUserData[ASSIGNEE_TYPE.CREATE]
        ? selectUserData[ASSIGNEE_TYPE.CREATE]
        : []),
      ...(selectDepartmentData[ASSIGNEE_TYPE.CREATE]
        ? selectDepartmentData[ASSIGNEE_TYPE.CREATE]
        : []),
      ...(selectGroupData[ASSIGNEE_TYPE.CREATE]
        ? selectGroupData[ASSIGNEE_TYPE.CREATE]
        : []),
    ])

    setHandlerList([
      ...(selectUserData[ASSIGNEE_TYPE.COMBINER]
        ? selectUserData[ASSIGNEE_TYPE.COMBINER]
        : []),
      ...(selectDepartmentData[ASSIGNEE_TYPE.COMBINER]
        ? selectDepartmentData[ASSIGNEE_TYPE.COMBINER]
        : []),
      ...(selectGroupData[ASSIGNEE_TYPE.COMBINER]
        ? selectGroupData[ASSIGNEE_TYPE.COMBINER]
        : []),
    ])
  }, [selectUserData, selectDepartmentData, selectGroupData])

  const handleChangeTabs = useCallback(
    async tab => {
      selectPeopleStore.clearSelected()
      form.setFieldsValue({
        search: null,
        date: null,
        status: undefined,
      })

      handleCloseCollapse()
      workStore.setQueryParams({
        ...queryParams,
        page: 0,
        permission: tab,
        parent_id: null,
        title: null,
        from_date: null,
        to_date: null,
        status: undefined,
        assignee: null,
      })

      const queryStringStringify = queryString.stringify(
        {
          ...queryStringParse,
          permission: tab,
          parent_id: null,
          title: null,
          from_date: null,
          to_date: null,
          status: undefined,
          assignee: null,
        },
        {
          skipNull: true,
        }
      )

      history.replace(`/works?${queryStringStringify}`)
    },
    [
      form,
      handleCloseCollapse,
      history,
      queryParams,
      queryStringParse,
      selectPeopleStore,
      workStore,
    ]
  )

  const onSearchTitle = useCallback(
    async title => {
      handleCloseCollapse()
      workStore.setQueryParams({
        ...queryParams,
        page: 0,
        title: title ? title.trim() : null,
        parent_id: null,
      })
      const queryStringStringify = queryString.stringify(
        {
          ...queryStringParse,
          title: title ? title.trim() : null,
          parent_id: null,
        },
        {
          skipNull: true,
        }
      )
      history.replace(`/works?${queryStringStringify}`)
      // await getWorkList()
    },
    [
      form,
      handleCloseCollapse,
      history,
      queryParams,
      queryStringParse,
      workStore,
    ]
  )

  const onChangeDate = useCallback(
    async value => {
      handleCloseCollapse()
      workStore.setQueryParams({
        ...queryParams,
        from_date: value ? moment(value[0]).format(ISO_DATE_FORMAT) : null,
        to_date: value ? moment(value[1]).format(ISO_DATE_FORMAT) : null,
        parent_id: null,
        page: 0,
      })
      const queryStringStringify = queryString.stringify(
        {
          ...queryStringParse,
          from_date: value ? moment(value[0]).format(ISO_DATE_FORMAT) : null,
          to_date: value ? moment(value[1]).format(ISO_DATE_FORMAT) : null,
          parent_id: null,
        },
        {
          skipNull: true,
        }
      )
      history.replace(`/works?${queryStringStringify}`)
      // await getWorkList()
    },
    [
      form,
      handleCloseCollapse,
      history,
      queryParams,
      queryStringParse,
      workStore,
    ]
  )

  const onChangeStatus = useCallback(
    async value => {
      // Khởi tạo các biến với giá trị mặc định là null
      let status = null
      let is_due_soon = null

      // Chỉ gán giá trị cho trạng thái được chọn, các trạng thái khác sẽ bị xóa
      if (value === 'DUE_SOON') {
        is_due_soon = true // Chọn "Sắp đến hạn"
      } else if (value) {
        status = value // Chọn "Hoàn thành" hoặc "Chưa hoàn thành"
      }

      // Cập nhật queryParams với trạng thái mới, đảm bảo xóa các trạng thái cũ
      workStore.setQueryParams({
        ...queryParams,
        status: status, // Chỉ giữ trạng thái được chọn
        is_due_soon: is_due_soon, // Chỉ giữ is_due_soon nếu được chọn
        page: 0, // Reset về trang đầu tiên
        parent_id: null,
      })

      // Tạo query string mới
      const queryStringStringify = queryString.stringify(
        {
          ...queryStringParse,
          status: status,
          is_due_soon: is_due_soon,
          parent_id: null,
        },
        {
          skipNull: true, // Loại bỏ các giá trị null khỏi query string
        }
      )

      // Cập nhật URL
      history.replace(`/works?${queryStringStringify}`)
    },
    [queryParams, queryStringParse, workStore, history]
  )

  const handleSubmitSelect = useCallback(async () => {
    setIsVisibleSelectGroupPopup(false)
    setIsVisibleSelectUserDepartmentPopup(false)

    if (selectGroupData[assigneePopupType].length > 0) {
      dispatchUserFilter({
        type: assigneePopupType,
        value: selectGroupData[assigneePopupType][0].id,
        fullName: selectGroupData[assigneePopupType][0].full_name,
        assigneeType: ASSIGNEE_TYPE.GROUP,
      })
      return
    }
    if (selectUserData[assigneePopupType].length > 0) {
      dispatchUserFilter({
        type: assigneePopupType,
        value: selectUserData[assigneePopupType][0].id,
        fullName: selectUserData[assigneePopupType][0].full_name,
        assigneeType: ASSIGNEE_TYPE.USER,
      })
      return
    }

    if (selectDepartmentData[assigneePopupType].length > 0) {
      dispatchUserFilter({
        type: assigneePopupType,
        value: selectDepartmentData[assigneePopupType][0].id,
        fullName: selectDepartmentData[assigneePopupType][0].full_name,
        assigneeType: ASSIGNEE_TYPE.DEPARTMENT,
      })
      return
    }

    dispatchUserFilter({
      type: assigneePopupType,
      value: null,
      fullName: null,
      assigneeType: ASSIGNEE_TYPE.USER,
    })
  }, [
    assigneePopupType,
    dispatchUserFilter,
    selectDepartmentData,
    selectGroupData,
    selectUserData,
    setIsVisibleSelectGroupPopup,
    setIsVisibleSelectUserDepartmentPopup,
  ])

  const markAsRead = useCallback(() => {
    let batchMarkAsRead = []
    selectedRowKeys.forEach(docId => {
      batchMarkAsRead.push(workStore.getWorkDetail(docId, null))
    })
    setMarkAsReadLoading(true)
    Promise.all(batchMarkAsRead).finally(() => {
      setMarkAsReadLoading(false)
      setSelectedRowKeys([])
      workStore.getWorkList()
    })
  }, [selectedRowKeys, setMarkAsReadLoading, setSelectedRowKeys, workStore])

  return (
    <>
      <Tabs
        activeKey={queryParams.permission || ''}
        onChange={handleChangeTabs}>
        <TabPane tab="Tất cả" key={''} />
        <TabPane tab="Đã tạo" key={ASSIGNEE_TYPE.CREATE} />
        <TabPane tab="Tôi xử lý" key={ASSIGNEE_TYPE.HANDLER} />
        <TabPane tab="Tôi theo dõi" key={ASSIGNEE_TYPE.FOLLOWER} />
      </Tabs>
      <Form form={form}>
        <Row gutter={[14, 14]} style={{ marginBottom: 20 }}>
          <Col xl={5} lg={12} md={24} xs={24}>
            <Form.Item name={'search'}>
              <Input.Search
                allowClear
                onSearch={value => onSearchTitle(value)}
                placeholder={'Tìm kiếm theo tiêu đề ...'}
                style={{ width: '100%' }}
                defaultValue={queryStringParse.title}
                maxLength={500}
              />
            </Form.Item>
          </Col>
          <Col xl={5} lg={12} md={12} xs={24}>
            <Form.Item name={'date'}>
              <RangePicker
                placeholder={['Bắt đầu', 'Kết thúc']}
                style={{ width: '100%' }}
                onChange={onChangeDate}
                defaultValue={
                  queryParams.from_date && queryParams.to_date
                    ? [
                        moment(queryParams.from_date),
                        moment(queryParams.to_date),
                      ]
                    : null
                }
                format={[DATE_FORMAT_DEFAULT, DATE_FORMAT_DEFAULT]}
              />
            </Form.Item>
          </Col>
          <Col xl={5} lg={12} md={12} xs={24}>
            <Form.Item name={'status'}>
              <Select
                allowClear
                placeholder={'Trạng thái'}
                style={{ width: '100%' }}
                onChange={onChangeStatus}
                value={
                  queryParams.is_due_soon ? 'DUE_SOON' : queryParams.status
                }>
                <Option value={WORK_STATUS.COMPLETE}>Hoàn thành</Option>
                <Option value={WORK_STATUS.PENDING}>Chưa hoàn thành</Option>
                {/* Lọc công việc sắp đến hạn (Không phải STATUS) */}
                <Option value="DUE_SOON">Sắp đến hạn</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <Row gutter={[14, 14]} style={{ marginBottom: 18 }}>
        <Col xl={5} lg={12} md={24} xs={24}>
          <Space
            style={{
              width: 180,
              verticalAlign: 'middle',
              display: 'inline-block',
            }}>
            {selectedRowKeys && selectedRowKeys.length > 0 ? (
              <Button
                loading={markAsReadLoading}
                onClick={markAsRead}
                disabled={!selectedRowKeys || selectedRowKeys.length === 0}>
                <CheckOutlined />
                Đánh dấu đã đọc
              </Button>
            ) : (
              <Tooltip placement="top" title={'Chưa chọn đối tượng'}>
                <Button disabled={true} style={{ marginLeft: '0px' }}>
                  <CheckOutlined />
                  Đánh dấu đã đọc
                </Button>
              </Tooltip>
            )}
          </Space>
        </Col>
        <Col xl={5} lg={12} md={24} xs={24}>
          <div
            style={{
              marginBottom: 8,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}>
            <span>Người tạo:</span>
            <Space>
              <Tooltip title="Chọn người dùng" color={blue}>
                <Button
                  icon={<UserOutlined style={{ color: blue }} />}
                  onClick={() =>
                    selectPeopleStore.handleOpenSelectUserDepartmentPopup(
                      ASSIGNEE_TYPE.CREATE
                    )
                  }
                />
              </Tooltip>
            </Space>
          </div>

          <SelectList>
            <div style={{ marginBottom: 8 }}>
              {createList.map(el => (
                <Tag
                  className={'tag-selected'}
                  color={'blue'}
                  key={el.id}
                  closable
                  onClose={() => {
                    dispatchUserFilter({
                      type: el.permission,
                      value: null,
                      fullName: null,
                      assigneeType: null,
                    })
                    selectPeopleStore.handleRemoveSelect(el)
                  }}>
                  <AvatarHasName
                    imgId={el.image_id}
                    size={22}
                    name={el.full_name}
                    icon={
                      (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                        <BankOutlined />
                      )) ||
                      (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                        <TeamOutlined />
                      ))
                    }
                  />
                </Tag>
              ))}
            </div>
          </SelectList>
        </Col>

        <Col xl={5} lg={12} md={24} xs={24}>
          <div
            style={{
              marginBottom: 8,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}>
            <span>Người xử lý:</span>
            <Space>
              <Tooltip title="Chọn người dùng" color={blue}>
                <Button
                  icon={<UserOutlined style={{ color: blue }} />}
                  onClick={() =>
                    selectPeopleStore.handleOpenSelectUserDepartmentPopup(
                      ASSIGNEE_TYPE.COMBINER
                    )
                  }
                />
              </Tooltip>
              <Tooltip title="Chọn nhóm" color={'#ffc069'}>
                <Button
                  icon={<TeamOutlined />}
                  style={{ color: yellowPrimary }}
                  onClick={() =>
                    handleOpenSelectGroupPopup(ASSIGNEE_TYPE.COMBINER)
                  }
                />
              </Tooltip>
            </Space>
          </div>
          <SelectList>
            <div style={{ marginBottom: 8 }}>
              {handlerList.map(el => (
                <Tag
                  className={'tag-selected'}
                  color={'blue'}
                  key={el.id}
                  closable
                  onClose={() => {
                    dispatchUserFilter({
                      type: el.permission,
                      value: null,
                      fullName: null,
                      assigneeType: null,
                    })
                    selectPeopleStore.handleRemoveSelect(el)
                  }}>
                  <AvatarHasName
                    imgId={el.image_id}
                    size={22}
                    name={el.full_name}
                    icon={
                      (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                        <BankOutlined />
                      )) ||
                      (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                        <TeamOutlined />
                      ))
                    }
                  />
                </Tag>
              ))}
            </div>
          </SelectList>
        </Col>
      </Row>

      <SelectPeoplePopup
        // id={'list-work-select-people-popup'}
        onlySelectOne
        handleCancelSelectUser={handleCancelSelectUserDepartment}
        handleSubmitSelectUser={handleSubmitSelect}
        isVisibleSelectPeoplePopup={isVisibleSelectUserDepartmentPopup}
      />

      <SelectGroupPopup
        // id={'list-work-select-group-popup'}
        onlySelectOne
        groupType={'cong_viec'}
        isVisibleSelectGroupPopup={isVisibleSelectGroupPopup}
        handleCancelSelectGroup={handleCancelSelectGroup}
        handleSubmitSelectGroup={handleSubmitSelect}
      />
    </>
  )
}

Search.propTypes = {}

export default memo(
  inject(
    'workStore',
    'loadingAnimationStore',
    'selectPeopleStore',
    'authenticationStore',
    'commandStore'
  )(observer(Search))
)
